'use strict'

import { EntityActions } from '../common/base/entity';
// import {EntityComponent} from '../entity'

export class jobAction extends EntityActions {
    constructor(options) {
        super(options);
    }

    postActionsHooks({actionName, item, tenantId }){
        switch (actionName) {
            case 'getAll':

                item = item.map(elem => {
                    if (elem.successChunk && elem.successChunk.successData && elem.successChunk.successData.downloadLink) {
                        elem.successChunk = elem.successChunk.successData.downloadLink
                    } else if (elem.successChunk && elem.successChunk.successData.publishStatus) {
                        elem.successChunk = elem.successChunk.successData.publishStatus
                    } else if (elem.successChunk && elem.successChunk.successData && elem.successChunk.successData.message) {
                        elem.successChunk = elem.successChunk.successData.message
                    } else if (elem.successChunk && elem.successChunk.successData) {
                        if (elem.successChunk.successData.constructor == Object && Object.keys(elem.successChunk.successData).length == 0) {
                            elem.successChunk = ""
                        } else {
                            elem.successChunk = JSON.stringify(elem.successChunk.successData)
                        }
                    } else if (elem.successChunk == null) {
                        elem.successChunk = ""
                    } else {
                        elem.successChunk = JSON.stringify(elem.successChunk)
                    }

                    if (elem.failedChunk && elem.failedChunk.errorData && elem.failedChunk.errorData.length > 0 && Array.isArray(elem.failedChunk.errorData)) {
                        elem.failedChunk = elem.failedChunk.errorData.join("; ")
                    } else if (elem.failedChunk && elem.failedChunk.errorData) {
                        if (elem.failedChunk.errorData.length == 0) {
                            elem.failedChunk = ""
                        } else {
                            elem.failedChunk = JSON.stringify(elem.failedChunk.errorData)
                        }
                    } else if (elem.failedChunk == null) {
                        elem.failedChunk = ""
                    } else {
                        elem.failedChunk = JSON.stringify(elem.failedChunk)
                    }

                    // elem.id = 'R#' + elem.createdAt.replaceAll('-', '').replaceAll(':', '').replaceAll(/\.[0-9]{0,5}Z/ig, '')

                    return elem
                })

                return item
            case 'getOne':
                  item = Object.assign({}, item, item.successChunk, item.failedChunk);
                  item.successCount = item.successData && item.successData.length
                  item.errorCount = item.errorData && item.errorData.length || 0
                  return item
            default:
                return item
        }
    }
}